import type { LogFunctions, LoggerConfiguration } from './logger.types'
import { LoggerProvider } from './providers/logger.providers'

/**
 * Public service consumed by rest of codebase to provide access to logging.
 */
class LoggerService {
    private loggerProvider: LoggerProvider

    public constructor(configuration: LoggerConfiguration) {
        this.loggerProvider = new LoggerProvider(configuration)
    }

    public createTag(tag: string | string[]): LogFunctions {
        return this.loggerProvider.tag(tag) as LogFunctions
    }
}

const noOpLogFunctions: LogFunctions = {
    trace: () => {},
    debug: () => {},
    info: () => {},
    warn: () => {},
    error: () => {},
}

export class LazyTagLogger {
    private _logger: LogFunctions | undefined
    private _init: () => LogFunctions

    public constructor(public tag: string | string[]) {
        this._init = () => {
            return _loggerService?.createTag(tag) ?? noOpLogFunctions
        }
    }

    public get value(): LogFunctions {
        return (this._logger ??= this._init())
    }
}

// eslint-disable-next-line no-var -- global availability?
var _loggerService: LoggerService | undefined = undefined

export function initialiseLogger(configuration: LoggerConfiguration) {
    _loggerService = new LoggerService(configuration)
}

export const getLogger = (tag: string | string[]): LazyTagLogger => {
    return new LazyTagLogger(tag)
}
